var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 699.959,
    height: 741.26,
    viewBox: "0 0 699.959 741.26",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499",
    transform: "translate(-747.313 -123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(747.313 347.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_560-219",
    "data-name": "Path 560",
    d: "M898.171,798.893s14.75,12.42,22.513,11.645,22.513-.777,16.3,7.763-31.83,13.2-42.7,13.971-34.928,1.553-33.383-3.105,3.105-26.4,9.315-27.943S898.171,798.893,898.171,798.893Z",
    transform: "translate(-769.264 -316.584)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561-220",
    "data-name": "Path 561",
    d: "M991.744,787.4s10.87,15.929,18.556,17.267,21.895,5.3,13.622,11.86-34.205,4.158-44.883,1.984-34.067-7.894-31.32-11.963S957.8,781.957,964.2,782.13,991.744,787.4,991.744,787.4Z",
    transform: "translate(-947.496 -317.282)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562-221",
    "data-name": "Path 562",
    d: "M1009.8,569.1s9.991,68.426,7.663,80.849-3.882,31.83-3.882,31.83,1.552,16.3,0,24.066-9.316,107.911-10.093,107.911-31.053,3.105-32.606,0,1.553-46.581,1.553-46.581,1.552-38.04,2.33-61.331-6.986-47.356-6.986-47.356A88.822,88.822,0,0,1,947.6,710.505c-20.185,24.066-30.278,69.093-30.278,69.093s-3.063,10.417-.735,16.628-30.318,1.222-32.648-1.1,6.21-21.738,6.21-24.843,13.971-70.646,35.711-90.054l1.553-70.646S908,559.9,928.189,555.24,1009.8,569.1,1009.8,569.1Z",
    transform: "translate(-872.258 -326.788)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563-222",
    "data-name": "Path 563",
    d: "M952.873,392.619s-13.2,32.606-10.093,37.263-38.04-15.527-38.04-15.527,13.2-32.606,13.2-36.488S952.873,392.619,952.873,392.619Z",
    transform: "translate(-829.401 -334.188)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_89",
    "data-name": "Ellipse 89",
    cx: 28.725,
    cy: 28.725,
    rx: 28.725,
    ry: 28.725,
    transform: "translate(85.043 9.134)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564-223",
    "data-name": "Path 564",
    d: "M919.352,400.5a27.244,27.244,0,0,1,24.625,9.8c10.092,12.421,11.645,15.527,11.645,15.527s24.066,38.818,19.408,58.226a56.173,56.173,0,0,0-3.105,5.435c-1.553,3.105-1.553,46.58,0,53.568s3.105,9.315,1.552,19.408,12.415,26.394-3.895,29.506-34.928-17.855-52.015-17.855a41.083,41.083,0,0,1-27.943-11.645s5.435-28.725,6.985-32.606-11.233-66.041,0-90.829,15.527-29.5,15.527-29.5S914.694,398.173,919.352,400.5Z",
    transform: "translate(-838.354 -333.233)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565-224",
    "data-name": "Path 565",
    d: "M915.823,471v34.158l24.843,82.291s16.3,42.7,0,42.7-15.43-40.754-15.43-40.754L890.2,527.671s-13.971-48.908-12.421-52.791S915.823,471,915.823,471Z",
    transform: "translate(-796.233 -330.276)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_566-225",
    "data-name": "Path 566",
    d: "M931.957,422.561s23.29,9.315,17.08,34.158,0,24.066,0,24.066-31.83-3.105-41.914,3.882l-2.33-9.315S895.478,421.783,931.957,422.561Z",
    transform: "translate(-825.565 -332.299)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_567-226",
    "data-name": "Path 567",
    d: "M945.935,352.279A11.46,11.46,0,0,0,956.7,350.6a8.673,8.673,0,0,0,2.445-10.238c-1.486-2.917-4.666.7-7.716-.5a71.7,71.7,0,0,0-21.013-4.745,19.118,19.118,0,0,0-10.107,1.364c-1.516.775-2.833,1.9-4.334,2.7-2.761,1.479-5.975,1.808-8.959,2.759-6.177,2.015-11.177,1.4-13.7,7.389a27.02,27.02,0,0,0-1.689,6.254,34.83,34.83,0,0,0,1.811,17.436c3.31,8.811,10.25,16.514,10.643,25.919,4.247-3.082,5.824-8.645,9.228-12.639a17.192,17.192,0,0,1,9.813-5.692c1.058-.065,3.889-2.641,6.9-17.29.592-2.794,1.34-5.838,3.634-7.536a11,11,0,0,1,4.738-1.67,74.312,74.312,0,0,1,12.136-1.107",
    transform: "translate(-820.713 -334.942)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7625-227",
    "data-name": "Path 7625",
    d: "M600.44,708.689H209.162V208.649H600.44Z",
    transform: "translate(846.833 -85.649)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7623-228",
    "data-name": "Path 7623",
    d: "M509.381,691.394H209.162V208.649H509.381Z",
    transform: "translate(924.805 -77.03)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1494",
    "data-name": "Rectangle 1494",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 453.784)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1495",
    "data-name": "Rectangle 1495",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 470.01)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1496",
    "data-name": "Rectangle 1496",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 486.236)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1189",
    "data-name": "Ellipse 1189",
    cx: 4.073,
    cy: 4.073,
    rx: 4.073,
    ry: 4.073,
    transform: "translate(1188.279 453.746)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1497",
    "data-name": "Rectangle 1497",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 383.866)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1498",
    "data-name": "Rectangle 1498",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 400.092)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1499",
    "data-name": "Rectangle 1499",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 416.318)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1190",
    "data-name": "Ellipse 1190",
    cx: 4.073,
    cy: 4.073,
    rx: 4.073,
    ry: 4.073,
    transform: "translate(1188.279 383.149)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1500",
    "data-name": "Rectangle 1500",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 524.381)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1501",
    "data-name": "Rectangle 1501",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 540.607)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1502",
    "data-name": "Rectangle 1502",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 556.833)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1191",
    "data-name": "Ellipse 1191",
    cx: 4.073,
    cy: 4.073,
    rx: 4.073,
    ry: 4.073,
    transform: "translate(1188.279 523.664)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1503",
    "data-name": "Rectangle 1503",
    width: 59.104,
    height: 11.321,
    rx: 5.66,
    transform: "translate(1065.514 156.652)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1504",
    "data-name": "Rectangle 1504",
    width: 59.104,
    height: 11.321,
    rx: 5.66,
    transform: "translate(1065.514 204.485)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1505",
    "data-name": "Rectangle 1505",
    width: 59.104,
    height: 11.321,
    rx: 5.66,
    transform: "translate(1065.514 252.319)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1506",
    "data-name": "Rectangle 1506",
    width: 59.104,
    height: 11.321,
    rx: 5.66,
    transform: "translate(1065.514 300.152)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1507",
    "data-name": "Rectangle 1507",
    width: 59.104,
    height: 11.321,
    rx: 5.66,
    transform: "translate(1065.514 347.986)",
    fill: "#17B8A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333-229",
    "data-name": "Path 333",
    d: "M15.18,489.13c0,1.075.348,1.939.782,1.939H405.676c.434,0,.782-.864.782-1.939s-.348-1.939-.782-1.939H15.962C15.528,487.191,15.18,488.054,15.18,489.13Z",
    transform: "translate(1040.814 -302.901)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7626-230",
    "data-name": "Path 7626",
    d: "M15.18,489.13c0,1.075.348,1.939.782,1.939H405.676c.434,0,.782-.864.782-1.939s-.348-1.939-.782-1.939H15.962C15.528,487.191,15.18,488.054,15.18,489.13Z",
    transform: "translate(1040.814 -255.068)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7627-231",
    "data-name": "Path 7627",
    d: "M15.18,489.13c0,1.075.348,1.939.782,1.939H405.676c.434,0,.782-.864.782-1.939s-.348-1.939-.782-1.939H15.962C15.528,487.191,15.18,488.054,15.18,489.13Z",
    transform: "translate(1040.814 -207.234)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7628-232",
    "data-name": "Path 7628",
    d: "M15.18,489.13c0,1.075.348,1.939.782,1.939H405.676c.434,0,.782-.864.782-1.939s-.348-1.939-.782-1.939H15.962C15.528,487.191,15.18,488.054,15.18,489.13Z",
    transform: "translate(1040.814 -159.4)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1508",
    "data-name": "Rectangle 1508",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 302.692)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1509",
    "data-name": "Rectangle 1509",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 254.858)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1510",
    "data-name": "Rectangle 1510",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 207.025)",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1511",
    "data-name": "Rectangle 1511",
    width: 176.791,
    height: 6.241,
    rx: 3.12,
    transform: "translate(1203.083 153.531)",
    fill: "#e5e5e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsign);
export default __webpack_public_path__ + "static/media/asign.e2c568d7f8407f93330c89bd2a0de9af.svg";
export { ForwardRef as ReactComponent };